/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminProfileUpdateDto
 */
export interface AdminProfileUpdateDto {
    /**
     * Admin first name
     * @type {string}
     * @memberof AdminProfileUpdateDto
     */
    firstName: string;
    /**
     * Admin middle name
     * @type {string}
     * @memberof AdminProfileUpdateDto
     */
    middleName?: string;
    /**
     * Admin last name
     * @type {string}
     * @memberof AdminProfileUpdateDto
     */
    lastName: string;
    /**
     * Admin phone number
     * @type {string}
     * @memberof AdminProfileUpdateDto
     */
    phone?: string;
    /**
     * Admin avatar URL
     * @type {string}
     * @memberof AdminProfileUpdateDto
     */
    avatar?: string;
}

/**
 * Check if a given object implements the AdminProfileUpdateDto interface.
 */
export function instanceOfAdminProfileUpdateDto(value: object): value is AdminProfileUpdateDto {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function AdminProfileUpdateDtoFromJSON(json: any): AdminProfileUpdateDto {
    return AdminProfileUpdateDtoFromJSONTyped(json, false);
}

export function AdminProfileUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProfileUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'avatar': json['avatar'] == null ? undefined : json['avatar'],
    };
}

export function AdminProfileUpdateDtoToJSON(json: any): AdminProfileUpdateDto {
    return AdminProfileUpdateDtoToJSONTyped(json, false);
}

export function AdminProfileUpdateDtoToJSONTyped(value?: AdminProfileUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'phone': value['phone'],
        'avatar': value['avatar'],
    };
}

